export const PAGE_ACTIVITY_TREE_VIEW = "PAGE_ACTIVITY_TREE_VIEW";
export const PAGE_ACTIVITY_CLIENT_INFO = "PAGE_ACTIVITY_CLIENT_INFO";
export const PAGE_ACTIVITY_BULK_REVIEW = "PAGE_ACTIVITY_BULK_REVIEW";
export const PAGE_ACTIVITY_ACCURACY = "PAGE_ACTIVITY_ACCURACY";

 
